var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrencyTry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136710)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136710)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -2,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.88281 -3.44141H45.9982V31.1459H-5.88281V-3.44141Z",
    fill: "#E30A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.186 13.8524L26.0073 11.3114L21.1732 17.9643V9.74054L26.0073 16.3934L18.186 13.8524ZM18.7192 18.4761C17.7174 20.0592 16.2286 21.2741 14.4767 21.9381C12.7249 22.602 10.8048 22.679 9.00544 22.1575C7.20606 21.636 5.62473 20.5442 4.4994 19.0464C3.37407 17.5486 2.76562 15.7258 2.76562 13.8524C2.76562 11.979 3.37407 10.1562 4.4994 8.65843C5.62473 7.16064 7.20606 6.06885 9.00544 5.54734C10.8048 5.02584 12.7249 5.10283 14.4767 5.76674C16.2286 6.43065 17.7174 7.64556 18.7192 9.22865C17.7837 8.18767 16.5545 7.45493 15.1938 7.12723C13.8331 6.79953 12.405 6.89226 11.0982 7.3932C9.79134 7.89414 8.66717 8.7797 7.87417 9.93294C7.08116 11.0862 6.65662 12.4528 6.65662 13.8524C6.65662 15.252 7.08116 16.6186 7.87417 17.7719C8.66717 18.9251 9.79134 19.8107 11.0982 20.3116C12.405 20.8125 13.8331 20.9053 15.1938 20.5776C16.5545 20.2499 17.7837 19.5171 18.7192 18.4761Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136710"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    y: -2,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyTry);
export default __webpack_public_path__ + "static/media/Currency=TRY.712ba148954482d5b54cb8abf6725a30.svg";
export { ForwardRef as ReactComponent };